import { Navigate, useLocation } from 'react-router-dom';
import { getRoleFromToken } from './api'

const PrivateRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const userRole = getRoleFromToken();
  const location = useLocation();

  if (!token) {
    const redirectTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/?redirect_to=${redirectTo}`} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/inicio" replace />;
  }

  return children;
};

export default PrivateRoute;